module.exports = __webpack_public_path__ + "static/media/icon-file.6d42b76e.svg";